import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud",
  "use": "icon-cloud-usage",
  "viewBox": "0 0 1098 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1098 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cloud\"><path d=\"M1097.142857 658.285714q0 90.857143-64.285714 155.142857t-155.142857 64.285714l-621.714286 0q-105.714286 0-180.857143-75.142857t-75.142857-180.857143q0-75.428571 40.571429-138t106.857143-93.428571q-1.142857-16-1.142857-24.571429 0-121.142857 85.714286-206.857143t206.857143-85.714286q90.285714 0 163.714286 50.285714t107.142857 131.428571q40-35.428571 94.857143-35.428571 60.571429 0 103.428571 42.857143t42.857143 103.428571q0 42.857143-23.428571 78.857143 73.714286 17.142857 121.714286 76.857143t48 136.857143z\" p-id=\"38007\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cloud.svg
// module id = Yvcf
// module chunks = 61